<template>
    <div>
        <StaffGroup
            v-if="collaborators.length"
            :placeholder="$t.__('timeline.TimelineAuthorFilter.all_staff')"
            :collaborators="collaborators"
            :selectedCollaborator="selected"
            @input="collaboratorsSelected"
        />
        <span v-else>{{ $filters.capitalize($l10n.__('indisponible')) }}</span>
    </div>
</template>
<script>
import StaffGroup from 'vcomponents/inputs/custom/StaffGroup.vue';
import ActivitiesListings from 'vcomponents/listing/config/activitiesListings.js';

export default {
    components: {
        StaffGroup,
    },
    props: {
        selected: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            collaborators: [],
        };
    },
    created() {
        this.fetch();
    },
    methods: {
        fetch() {
            const crmActivitiesListing = ActivitiesListings.find(
                (listing) => listing.id == 'crm-activity',
            );
            return ApiClient.get(crmActivitiesListing.metaUrl)
                .then((response) => {
                    const authors = response.data.authors;
                    const groups = [];
                    const noGroup = {
                        label: 'Autre',
                        value: '0',
                        children: [],
                    };
                    authors.map((author) => {
                        if (null == author.groups) {
                            noGroup.children.push({
                                label: author.firstname + ' ' + author.lastname,
                                value: author.id,
                            });
                        } else {
                            author.groups.map((group) => {
                                if (undefined == groups.find((one) => one.value == group.id)) {
                                    groups.push({
                                        label: group.name,
                                        value: group.id,
                                        children: [],
                                    });
                                }
                                if (undefined == groups.find((one) => one.value == group.id)) {
                                    return;
                                }
                                groups
                                    .find((one) => one.value == group.id)
                                    .children.push({
                                        label: author.firstname + ' ' + author.lastname,
                                        value: author.id,
                                    });
                            });
                        }
                    });
                    if (noGroup.children.length) {
                        groups.push(noGroup);
                    }
                    this.collaborators = groups;
                })
                .catch((_) =>
                    Push.error(
                        this.$l10n.__('Erreur lors de la récupération du filtre collaborateur'),
                    ),
                );
        },
        collaboratorsSelected(groups, collaborators) {
            this.$emit('input', 'authors', collaborators);
        },
    },
};
</script>
